import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div style={{ minHeight: '100%', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div className="card" style={{ maxWidth: 420, textAlign: 'center' }}>
        <div className="page-title">Page not found</div>
        <p style={{ color: 'var(--gray)', margin: '8px 0 16px' }}>
          That page doesn't exist or may have moved.
        </p>
        <Link className="btn btn-primary" to="/" style={{ textDecoration: 'none' }}>
          Go home
        </Link>
      </div>
    </div>
  )
}
